function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4 7V5.5C4 3.0175 4.75 1 8.5 1C12.25 1 13 3.0175 13 5.5V7",
    stroke: "#292D32",
    style: {
      stroke: "#292D32",
      stroke: "color(display-p3 0.1608 0.1765 0.1961)",
      strokeOpacity: 1
    },
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.3752C9.53553 13.3752 10.375 12.5358 10.375 11.5002C10.375 10.4647 9.53553 9.62524 8.5 9.62524C7.46447 9.62524 6.625 10.4647 6.625 11.5002C6.625 12.5358 7.46447 13.3752 8.5 13.3752Z",
    stroke: "#292D32",
    style: {
      stroke: "#292D32",
      stroke: "color(display-p3 0.1608 0.1765 0.1961)",
      strokeOpacity: 1
    },
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 16H4.75C1.75 16 1 15.25 1 12.25V10.75C1 7.75 1.75 7 4.75 7H12.25C15.25 7 16 7.75 16 10.75V12.25C16 15.25 15.25 16 12.25 16Z",
    stroke: "#292D32",
    style: {
      stroke: "#292D32",
      stroke: "color(display-p3 0.1608 0.1765 0.1961)",
      strokeOpacity: 1
    },
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.4b1d9b6882384dba3dc42900cf30820b.svg";
export { ForwardRef as ReactComponent };